import * as z from "zod";
export const contactSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  product: z.string().min(1, 'Product is required'),
  phone: z.string().min(10, 'Phone number is too short'),
  email_address: z.string().email('Invalid email address'),
  message: z.string().min(1, 'Message is required'),
  delivery_location: z.string().optional(),
  current_location: z.string().optional(),
});

export type ContactFormInputs = z.infer<typeof contactSchema>;